<template>
  <b-modal
    id="client-credit-card-on-file-modal"
    :title="trans('cc_on_file')"
    :ok-title="trans('close')"
    ok-variant="outline-primary"
    ok-only
    @shown="onShown"
    @hidden="onHidden"
  >
    <p>
      <i class="fa fa-fw fa-info-circle text-muted"></i>
      {{ trans('client_cc_on_file_about') }}
    </p>
    <br/>
    
    <p v-if="!!client">
      <span v-if="company" class="d-block">
        {{ company }}
      </span>
      <span v-if="name" class="d-block">
        {{ name }}
      </span>
      <span v-if="email" class="d-block">
        {{ email }}
      </span>
      <span v-if="mobile" class="d-block">
        {{ mobile }}
      </span>
      <span v-if="otherPhone" class="d-block">
        {{ otherPhone }}
      </span>
      <span v-if="address" class="d-block">
        {{ address }}
      </span>
    </p>

    <h6>{{ trans('cc_on_file') }}</h6>
    <p v-if="!!credit_card_on_file">
      <i class="fa fa-fw fa-credit-card"></i>
      {{ credit_card_on_file.card_display }}
    </p>
    <p v-if="!credit_card_on_file">
      <em class="text-muted">{{ trans('no_cc') }}</em>
    </p>
    <p>
      <b-button
        variant="outline-primary"
        size="sm"
        class="mr-2"
        @click="onClickUpdateCreditCardOnFile"
        :disabled="busy"
      >
        <i class="fa fa-fw fa-edit"></i>
        {{ trans(!!credit_card_on_file ? 'modify' : 'add') }}
      </b-button>
      <delete-button
        v-if="!!credit_card_on_file"
        variant="outline-danger"
        size="sm"
        class="mr-2"
        type="remove"
        :message="trans('remove_credit_card_on_file_warning')"
        @confirm="onClickRemoveCreditCardOnFile"
        :disabled="busy"
      >
        {{ trans('remove') }}
      </delete-button>
    </p>
    <br/>

    <stripe-credit-card-modal
      :id="updateCreditCardOnFileModalId"
      :organization="organization"
      :client="client"
      :recipient-id="recipientId"
      @saved="onCreditCardSaved"
    ></stripe-credit-card-modal>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import StripeCreditCardModal from './../payment/StripeCreditCardModal'
  import DeleteButton from './../../../common/components/DeleteConfirmButton'

  export default {
    props: {
      organization: Object,
      client: Object,
    },
    components: {
      StripeCreditCardModal,
      DeleteButton,
    },
    data() {
      return {
        trans: trans,
        currency: _.currency,
        busy: false,
        error: null,
        credit_card_on_file: null,
      }
    },
    computed: {
      recipientId() {
        return !!this.client ? this.client.recipient_id : null
      },
      name() {
        return !!this.client ? this.client.name : null
      },
      mobile() {
        return !!this.client ? this.client.mobile : null
      },
      email() {
        return !!this.client ? this.client.email : null
      },
      company() {
        return null
      },
      otherPhone() {
        return null
      },
      address() {
        return null
      },
      cardBrand() {
        return !!this.credit_card_on_file ?
          this.credit_card_on_file.card_brand :
          null
      },
      cardLastFour() {
        return !!this.credit_card_on_file ?
          this.credit_card_on_file.card_last_four :
          null
      },
      cardExp() {
        return !!this.credit_card_on_file && !!this.credit_card_on_file.card_exp ?
          this.credit_card_on_file.card_exp :
          null
      },
      updateCreditCardOnFileModalId() {
        return `stripe-credit-card-modal-${this.recipientId || ''}`
      },
    },
    methods: {
      onShown() {
        this.fetch()
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.recipient = null
      },
      onClickUpdateCreditCardOnFile() {
        this.$bvModal.show(this.updateCreditCardOnFileModalId)
      },
      onCreditCardSaved(credit_card_on_file) {
        this.credit_card_on_file = credit_card_on_file
      },
      onClickRemoveCreditCardOnFile() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/credit_card_on_file/${this.recipientId}`
        axios.delete(url)
        .then(response => {
          this.busy = false
          this.credit_card_on_file = null
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/credit_card_on_file/${this.recipientId}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.credit_card_on_file = !_.isEmpty(response.data) ? response.data : null
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.clientCreditCardOnFileModal = this
    },
  }
</script>